
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 6.5a4.14 4.14 0 00-3-4 1 1 0 00-2 0 4.13 4.13 0 00-3 4C4 9.19 3.67 10 3 10h10c-.67 0-1-.81-1-3.5zm1.5 4.5h-11a.5.5 0 000 1h4.09a1.39 1.39 0 00-.09.5 1.5 1.5 0 003 0 1.39 1.39 0 00-.09-.5h4.09a.5.5 0 000-1z"}})])
          )
        }
      }
    